import Link from '@/components/client/seo/link'
import { ImageWrapper } from '@/components/image'
import SvgArrowRight from '@/icons/regular/ArrowRight'

import type { AuthorDirectorySearchEntry } from './types'

export const AuthorSearchResultCard = ({ author }: { author: AuthorDirectorySearchEntry }) => (
  <article className="border-navy/10 rounded-2xl border bg-white/80 shadow-xs transition-shadow hover:shadow-sm">
    <Link
      href={author.profileHref}
      prefetch={false}
      data-tracking="ignore"
      className="group/result grid min-h-24 grid-cols-[4rem_minmax(0,1fr)_auto] items-center gap-4 p-4"
    >
      <figure className="bg-navy-10 relative m-0 aspect-square overflow-hidden rounded-2xl">
        {author.avatarUrl ? (
          <ImageWrapper
            image={author.avatarUrl}
            origin="authors-search-avatar"
            loadTime="lazy"
            imgProps={{
              alt: author.name,
              className: 'h-full w-full object-cover transition-transform group-hover/result:scale-[1.025]',
            }}
            sizingProps={{ fixed: false, minWidth: 64, maxWidth: 128, sizes: '64px' }}
          />
        ) : (
          <span className="text-navy/40 flex h-full items-center justify-center text-2xl font-semibold">
            {author.name.charAt(0)}
          </span>
        )}
      </figure>
      <div className="min-w-0">
        <h3 className="text-navy group-hover/result:text-lapis truncate text-lg font-semibold transition-colors">
          {author.name}
        </h3>
        {author.aboutBrief ? <p className="text-navy/55 mt-0.5 truncate text-sm">{author.aboutBrief}</p> : null}
        <p className="text-navy/45 mt-1.5 text-xs font-semibold">{author.storyCountLabel}</p>
      </div>
      <SvgArrowRight
        aria-hidden
        className="text-navy/35 h-3.5 w-3.5 transition-transform group-hover/result:translate-x-0.5"
      />
    </Link>
  </article>
)
